const BASE_PUBLIC = {
  BASE__PUBLIC_HASTERMINAL_ACCOUNTS: 'public/base/type/panel/has-terminal/accounts'
}
export default BASE_PUBLIC
